export enum TYPES_MESSAGES {
  NORMAL = "NORMAL",
  QUESTION = "QUESTION",
  ANNOUNCEMENT = "ANNOUNCEMENT",
  REACTION = "REACTION",
  PAPER_PLANE = "PAPER_PLANE",
  HAND_UP = "HAND_UP",
}
